import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    select: {
      color: theme.palette.primary.main,
      display: 'flex',
      alignSelf: 'center',
      '& .MuiOutlinedInput-notchedOutline': {
        border: 0,
      },
    },
    text: {
      textTransform: 'uppercase',
      fontWeight: 500,
      fontSize: '0.875rem',
    },
  };
};
